import { create } from 'zustand';

let toastId = 0;

export const useUiStore = create((set, get) => ({
  toasts: [],
  cheatsheetOpen: false,
  guidelinesOpen: false,
  // Superscript H/U/W letters on tags. Colour is never the only signal, but the letters
  // make the distinction unmissable for red/green-deficient annotators.
  showTagLetters: readFlag('ads.showTagLetters', false),

  toast(message, { tone = 'default', action = null, timeout = 4000 } = {}) {
    const id = (toastId += 1);
    set((s) => ({ toasts: [...s.toasts, { id, message, tone, action }] }));
    if (timeout) setTimeout(() => get().dismiss(id), timeout);
    return id;
  },
  dismiss(id) {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },

  toggleCheatsheet: () => set((s) => ({ cheatsheetOpen: !s.cheatsheetOpen })),
  closeCheatsheet: () => set({ cheatsheetOpen: false }),
  toggleGuidelines: () => set((s) => ({ guidelinesOpen: !s.guidelinesOpen })),
  closeGuidelines: () => set({ guidelinesOpen: false }),

  toggleTagLetters: () =>
    set((s) => {
      const next = !s.showTagLetters;
      writeFlag('ads.showTagLetters', next);
      return { showTagLetters: next };
    }),
}));

function readFlag(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? fallback : raw === 'true';
  } catch {
    return fallback;
  }
}

function writeFlag(key, value) {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* private mode; the preference just won't persist */
  }
}
